import { forEach } from 'lodash'

import { batchOpacityRevealAnimation } from './shared'
import { Animation } from '@/types'

export const clustersRevealAnimation = ({ context, reverse }: Animation) => {
  const clusters = context.selector?.('[data-motion-cluster]')

  let clustersBatchAnimation: ScrollTrigger[]
  if (clusters.length > 0) {
    clustersBatchAnimation = batchOpacityRevealAnimation({
      targets: clusters,
      reverse,
      stagger: {
        amount: 0.12
      }
    })
  }

  return () => {
    forEach(clustersBatchAnimation || [], (animation) => animation.kill())
  }
}
